export default {
  "menu": {
    "dashboard": "Bảng điều khiển",
    "orders": "Đặt hàng",
    "api": {
      "title": "API",
      "apiApps": "ứng dụng API?",
      "callbacks": "Gọi lại?",
      "requests": "Yêu cầu"
    },
    "profile": {
      "title": "Thông tin người dùng",
      "updateProfile": "Cập nhật thông tin",
      "updatePassword": "Thay đổi mật khẩu"
    },
    "payoutSettings": {
      "title": "Cài đặt tài khoản",
      "withdrawals": "Rút tiền",
      "wallets": {
        "title": "Ví",
        "bitcoin": "Bitcoin",
        "ethereum": "Ethereum",
        "cardano": "ADA (Cardano)"
      }
    },
    "apps": "Apps"
  },
  "headerMenu": {
    "profile": "Thông tin người dùng",
    "logout": "Đăng xuất"
  },
  "updateProfile": {
    "title": "Cập nhật thông tin",
    "fullName": "Họ tên",
    "email": "Email",
    "phoneCountry": "Mã số điện thoại quốc tế",
    "phone": "Số điện thoại",
    "timezone": "Múi giờ",
    "address": "Địa chỉ"
  },
  "updatePassword": {
    "title": "Thay đổi mật khẩu",
    "currentPassword": "Mật khẩu hiện tại",
    "newPassword": "Mật khẩu mới",
    "passwordConfirmation": "Nhập lại mật khẩu"
  },
  "button": {
    "edit": "Chỉnh sửa",
    "clear": "Xóa",
    "submit": "Xác nhận",
    "save": "Lưu",
    "cancel": "Hủy",
    "login": "Login",
    "createAnAccount": "Create an account",
    "register": "Register",
    "goToSignIn": "Go to sign in"
  },
  "app": {
    "name": "FG Payment"
  },
  "login": {
    "title": "Sign in",
    "forgotPassword": "Forgot Password?",
    "dontHaveAccount": "Don't have an account?"
  },
  "registration": {
    "title": "Registration",
    "haveAccount": "Already have an account?"
  },
  "forgotPassword": {
    "title": "Recover your password",
    "goBackLogin": "Go back to login",
    "sendResetLink": "Send reset link"
  },
  "resetPassword": {
    "title": "Reset your password",
    "resetButton": "Reset my password"
  },
  "common": {
    "email": "Email",
    "password": "Mật khẩu",
    "passwordConfirmation": "Nhập lại mật khẩu"
  }
}
